/*
  Домены сервисов
* */
// Dev
const MAIL_SENDER_API_DOMAIN  = 'https://mail-sender.black-it.ru';

const MAIL_SENDER_API_KEY = 'cfbaea843b5d4553b21d46d07580774e';

const recipientsMailSenderAPI = ['v.perekrestov@logistictech.ru', 'a.shalimof@yandex.ru',];

export { MAIL_SENDER_API_DOMAIN, MAIL_SENDER_API_KEY, recipientsMailSenderAPI, };
